module.exports = __webpack_public_path__ + "static/media/VU.4df78e9d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/VU.svg
// module id = 391
// module chunks = 0